// extracted by mini-css-extract-plugin
export default {"DepositTab":"DepositTab_DepositTab__EHLm4","buttonRow":"DepositTab_buttonRow__1fMwk","tableWrapper":"DepositTab_tableWrapper__vy1xP"};